<template>
<section>
    <b-overlay :show="showOverlay" rounded="lg" no-center="true">
        <template #overlay>
            <div class="text-center" style="margin-top: 100px;">
                <p id="cancel-label">{{ csvUploadMessage }}</p>
                <b-button class="btn green-rflocus" size="sm" @click="showOverlay = false">
                    OK
                </b-button>
            </div>
        </template>
    <div class="row">
        <div class="col-12">
            <div class="card-box">
                <slot name="back"></slot>
                 <button v-if="this.title === 'Stocks' && isUpdateFlag" type="button" class="btn btn-secondary"  style="float:right;margin-right:10px" @click="onclickItemCancel">
                        <span>{{$t("cancel")}}</span>
                    </button>

                    <button v-if="this.title === 'Stocks' && isUpdateFlag" type="button" class="btn btn-danger"  style="float:right;margin-right:10px" @click="onclickItemUpdate">
                            <span>{{$t("saveLocationChange")}}</span>
                    </button>
                <br>

                <b-table class="tablesaw list-container" :busy="loading" :items="items" :fields="fields" striped bordered @headClicked="sortChange" responsive :select-head="false" @rowSelected="$emit('row-selected', $event)" @rowUnselected="$emit('un-row-selected', $event)" :selectable="title === 'Stocks'" select-mode="single">
                    <template v-slot:head()="data">
                        <div style="white-space: nowrap">
                            <span>{{ data.label}}</span>
                            <i-bi-caret-down-fill v-if="fields.find(item=> item.label === data.label) === undefined || fields.find(item=> item.label === data.label).sortDirection === undefined" style="visibility: hidden" />
                            <i-bi-caret-up-fill v-else-if="fields.find(item=> item.label === data.label).sortDirection === 'asc'" />
                            <i-bi-caret-down-fill v-else-if="fields.find(item=> item.label === data.label).sortDirection === 'desc'" />
                        </div>
                    </template>

                   <template v-slot:cell(Stock.warehouseId)="row">
                        <div v-if="locationEditable && row.item.mapEditing === true">
                            <b-form-select v-model="row.value" :options="warehouseOptions" @change="changeItem($event, row.item, row.field.key)"></b-form-select>
                        </div>
                        <div v-else @click="clearLocationFocus(row)" style="cursor: pointer;">
                            {{ row.item['Stock.warehouseId']  || '&nbsp;'  }}
                        </div>
                    </template>

                    <template v-slot:cell(Stock.locationId)="row">
                        <div v-if="locationEditable && row.item.locationEditing === true">
                            <location-picker :key="''+ paginate.current_page + row.index" :index="''+ paginate.current_page + row.index" :modelValue="{label: row.item['Stock.locationId']}" :locationOptions="locationOptions" :lpWareHouseId="row.item.warehouseId" @locationInput="changeLocation('Stock.locationId', $event, row.item)"></location-picker>
                        </div>
                        <div v-else @click="clearMapFocus(row)"  style="cursor: pointer;">
                            {{ row.item['Stock.locationId']  || '&nbsp;' }}
                        </div>
                    </template>

                </b-table>

                <b-pagination align="center" :total-rows="paginate.total" :per-page="Number(paginate.per_page)" v-model="paginate.current_page" @page-click="updatePage" class="my-0" />

                <slot name="button"></slot>

            </div>
        </div>
    </div>
</b-overlay>
</section>
</template>

<script>
import Paginate from '../ThePaginate.vue'
import LocationPicker from "../LocationPicker.vue";
import {
    BPagination,
    BTable
} from "bootstrap-vue-next";
import {
    API
} from "aws-amplify";
import * as mutations from "../../graphql/locus_mutations";

export default {
    props: ['headers', 'loading', 'elements', 'paginate', 'sort', 'title', 'listWarehouses', 'locationOptions', 'warehouseId', 'locationEditable', 'searchParam'],
    components: {
        Paginate,
        BTable,
        BPagination,
        LocationPicker
    },
    data() {
        return {
            isUpdateFlag: false,
            showOverlay: false,
            csvUploadMessage: "",
        }
    },
    computed: {
        warehouseOptions() {
            return this.listWarehouses.map((item) => ({
                value: item.name,
                text: `${item.name}`,
            }));
        },
        fields() {
            let headers = this.headers
                .map((header) => {
                    if (header.source.includes(" as ")) {
                        header.source = header.source.split(" as ")[1]
                    }
                    
                    let index = 0;
                    if (this.sort.map(sort => sort.source).includes(header.source)) {

                        const direction = this.sort.find((item, i) => {
                            index = i;
                            return item.source === header.source;
                        }).direction === 'asc' ? 'asc' : 'desc';
                        return {
                            id: header.id,
                            key: header.source,
                            name: header.name,
                            index: index,
                            direction: direction,
                            class: ['sorting', "word-break-keep", direction],
                        }
                    } else {

                        return {
                            id: header.id,
                            key: header.source,
                            name: header.name,
                            class: ['sorting', "word-break-keep"],
                        }
                    }
                })
                .map((item) => {
                    const index = item.index >= 0 ? item.index + 1 : '';
                    return {
                        key: item.key,
                        label: `${item.name}`,
                        thClass: item.class,
                        sortDirection: item.direction === undefined ? '' :item.direction,
                        thAttr: {
                            index: index
                        }
                    }
                });
            return headers;
        },
        items(){
            return this.elements.map((item) =>{
                if(item.warehouseId === undefined ){
                    item.warehouseId = this.warehouseId
                    item.oldWarehouseId = this.warehouseId
                } else {
                    item.oldWarehouseId = item.warehouseId
                }
                return {
                    ...item,
                }
                
            })
        },
    },
    methods: {
        rowSelected(item) {
            this.$emit('rowSelected', item)
        },
        sortChange(sort) {
            this.$emit('sortChange', sort)
        },
        updatePage(BvEvent, page) {
            this.page = page;
            this.$emit('updatePage', page);
        },
        clearLocationFocus(row){
            row.item.mapEditing = true
            row.item.locationEditing = false
        },
        clearMapFocus(row){
            row.item.mapEditing = false
            row.item.locationEditing = true
        },
        changeItem(value, cell, key) {
            cell[key] = value;
            cell.isMapUpdate = true
            this.isUpdateFlag = true
            var currentWareHouse = this.listWarehouses.filter(item => item.name === cell["Stock.warehouseId"])
            if(currentWareHouse.length > 0){
                cell.warehouseId = currentWareHouse[0].id
            }
            cell["Stock.locationId"] = undefined
            cell.locationEditing = false
            this.$forceUpdate();
        },
        changeLocation(key, value, cell) {
            if (typeof value === 'string') {
                if(cell[key] === value){
                    return
                }
                cell[key] = value;
            } else {
                if(cell[key] === value.label){
                    return
                }
                cell[key] = value.label;
            }
            cell.isLocationUpdate = true
            cell.mapEditing = false
            this.isUpdateFlag = true
        },
        async onclickItemUpdate(){
             var updateList = this.items.filter(item => item.isMapUpdate || item.isLocationUpdate)
            if(updateList.length > 0) {
                const update = [];
                
                updateList.forEach(async element => {
                    var currentWareHouse = this.listWarehouses.filter(item => item.name === element["Stock.warehouseId"])
                    var currentLocation = this.locationOptions.filter(item => item.label === element["Stock.locationId"])
                    
                    var data = {
                        locationId: 0
                    }

                    if(element.isMapUpdate && element.isLocationUpdate) {
                        if(currentWareHouse.length > 0){
                            data.warehouseId = currentWareHouse[0].id
                        }
                        if(currentLocation.length > 0){
                            data.locationId = currentLocation[0].id
                        }
                    } else if(element.isMapUpdate){
                        if(currentWareHouse.length > 0){
                            data.warehouseId = currentWareHouse[0].id
                        }
                    }else if(element.isLocationUpdate){
                        if(currentLocation.length > 0){
                            data.locationId = currentLocation[0].id
                        }
                    }

                    var condition = {
                        ...this.searchParam,
                        warehouseId: parseInt(element.oldWarehouseId)
                    }
                    if(element["Stock.epc"] !== undefined && element["Stock.epc"] !== null && element["Stock.epc"] !== "") {
                        condition["epc"] = element["Stock.epc"]
                    }

                    update.push(API.graphql({
                        query: mutations.updateStocks2,
                        variables: {
                            data: JSON.stringify(data),
                            condition: JSON.stringify(condition),
                        }
                    }));
                });

                Promise.all([...update]).then((res) => {
                    var successFlag = true
                    this.showOverlay = true
                    res.forEach(response =>{
                        if(response !== undefined && response.data.updateStock2 !== undefined  && response.data.updateStock2 !== null && response.data.updateStock2 > 0) {
                        } else {
                            successFlag = false
                        }
                    })
                    if(successFlag) {
                        this.isUpdateFlag = false
                        this.csvUploadMessage = this.$t("update_success")
                        this.items.forEach(item=> {
                            item.locationEditing = false
                            item.mapEditing = false
                        })
                        this.$emit('updateFormSearch2')
                    } else {
                        this.csvUploadMessage = this.$t("update_error")
                    }
                })
            }
        },
        onclickItemCancel(){
            this.$emit('updateFormSearch2')
            this.isUpdateFlag = false
        }
    }
}
</script>

<style>
.table-yellow {
    background-color: yellow;
}

.table-grey {
    background-color: lightgrey;
}

.table-white {
    background-color: white;
}
.dropdown-menu {
  z-index: 1050;
  max-height: 300px;
  overflow-y: auto;
}
.list-container {
  overflow: visible;
  position: relative;
  z-index: 1;
  min-height: 300px;


}
</style>
